import type { StoredFavoriteSets } from '#features/FavoriteSets/exportFavoriteSetsAsJson'
import type { FavoriteSet, FavoriteSetId } from '#features/FavoriteSets/FavoriteSet'

export function createProposedMappings(imported: StoredFavoriteSets, existing: FavoriteSet[]) {
  const existingById = new Map<FavoriteSetId, FavoriteSet>()
  const existingByName = new Map<string, FavoriteSet[]>()
  const normalizeName = (name: string) => name.replace(/\s/g, '').trim().toLowerCase()
  for (let i = 0; i < existing.length; i++) {
    const set = existing[i]
    existingById.set(set.id, set)
    if (set.name) {
      const setName = normalizeName(set.name)
      const byName = existingByName.get(setName) || []
      byName.push(set)
      existingByName.set(setName, byName)
    }
  }

  const mapImportedToExisting = new Map<FavoriteSetId, FavoriteSetId>()

  for (const importedSet of imported.favoriteSets) {
    const idMatch = existingById.get(importedSet.id)
    if (idMatch) {
      mapImportedToExisting.set(importedSet.id, idMatch.id)
      continue
    }
    const setName = importedSet.name ? normalizeName(importedSet.name) : undefined
    if (setName) {
      const nameMatches = existingByName.get(setName)
      if (nameMatches && nameMatches.length > 0) {
        mapImportedToExisting.set(importedSet.id, nameMatches[0].id)
      }
    }
  }

  return mapImportedToExisting
}
